module.exports = __webpack_public_path__ + "static/media/diktat-26.f7e03b40.mp3";